package fr.labodoc.healthProfessional.api.payloads.responses

import kotlinx.serialization.Serializable

@Serializable
data class MarketingDocumentResponse(
  val marketingDocument: MarketingDocument
) {
  @Serializable
  data class MarketingDocument(
    val id: String,
    val name: String,
    val documentUrl: String,
    val version: Int,
    val latestVersionSeen: Int?
  )
}
